//src/services/auth.ts
import { api } from "./api";
import { setToken, getToken } from "../lib/tokenStorage";
import type { LoginRequest, LoginResponse, User } from "../types/Auth";

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const response = await api.post<LoginResponse>("/login", credentials);
  if (response.success && response.token) {
    setToken(response.token);
  }
  return response;
}

export async function logout(): Promise<{ success: boolean; message: string }> {
  try {
    const response = await api.post<{ success: boolean; message: string }>(
      "/logout"
    );
    setToken(null);
    return response;
  } catch (e) {
    setToken(null);
    throw e;
  }
}

export async function validateToken(): Promise<{
  success: boolean;
  user?: User;
  message?: string;
}> {
  const token = getToken();
  if (!token) return { success: false, message: "No token available" };
  try {
    return await api.get<{ success: boolean; user: User; message?: string }>(
      "/validate-token"
    );
  } catch (e) {
    setToken(null);
    throw e;
  }
}
